import { render, staticRenderFns } from "./orderSee.vue?vue&type=template&id=40d804a8&scoped=true&"
import script from "./orderSee.vue?vue&type=script&lang=js&"
export * from "./orderSee.vue?vue&type=script&lang=js&"
import style0 from "./orderSee.vue?vue&type=style&index=0&id=40d804a8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40d804a8",
  null
  
)

export default component.exports